import { useIsWorkSessionArtifactV2Enabled } from '@/features/flags';
import {
  useWorkChatContextHydrationCore,
  type WorkChatContextHydration,
} from '@heidi/agents/data';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/**
 * Binds Work chat hydration to the Next router and the session-artifact-v2 flag.
 * The router itself is the location, so the hydration effect still re-runs on
 * every navigation exactly as it did when it read `useRouter()` directly.
 */
export const useWorkChatContextHydration = ({
  projectId,
  chatInstanceId,
}: {
  projectId: string | undefined;
  chatInstanceId: string;
}): WorkChatContextHydration => {
  const router = useRouter();
  const isWorkSessionArtifactV2Enabled = useIsWorkSessionArtifactV2Enabled();
  const replaceQuery = useCallback(
    (query: Record<string, string | string[]>) => {
      void router.replace({ pathname: router.pathname, query }, undefined, {
        shallow: true,
      });
    },
    [router]
  );
  return useWorkChatContextHydrationCore(
    { projectId, chatInstanceId, isWorkSessionArtifactV2Enabled },
    router,
    replaceQuery
  );
};
